import { createAsyncThunk } from "@reduxjs/toolkit";
import { getLoyaltyTierSystemForCustomer } from "../../../utils/APICalls/APICalls";
import { LoyaltyTierSystemParams } from "../../../utils/loyaltyTypes";

export const fetchLoyaltyTierSystem = createAsyncThunk(
  "loyaltyTierSystem/fetch",
  async (params: LoyaltyTierSystemParams) => {
    const res = await getLoyaltyTierSystemForCustomer(params);

    return res.data;
  }
);
